/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_OEM_ADMIN_COUNTRY_DETAILS_REQUEST,
  FETCH_OEM_ADMIN_COUNTRY_DETAILS_SUCCESS,
  FETCH_OEM_ADMIN_COUNTRY_DETAILS_FAILURE,
} from "./OemAdminCountryDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchOemAdminCountriesDetailsRequest = () => {
  return {
    type: FETCH_OEM_ADMIN_COUNTRY_DETAILS_REQUEST,
  };
};

export const fetchOemAdminCountriesDetailsSuccess = (countriesData) => {
  return {
    type: FETCH_OEM_ADMIN_COUNTRY_DETAILS_SUCCESS,
    payload: countriesData,
  };
};

export const fetchOemAdminCountriesDetailsFailure = (error) => {
  return {
    type: FETCH_OEM_ADMIN_COUNTRY_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchAdminCountriesDetails = () => {
  return async function (dispatch) {
    dispatch(fetchOemAdminCountriesDetailsRequest());
    try {
      const data = await APIManager.getAdminCountries();
      dispatch(fetchOemAdminCountriesDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchOemAdminCountriesDetailsFailure(error));
      dispatch(commonError(error, FETCH_OEM_ADMIN_COUNTRY_DETAILS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
